import { useState } from 'react';
import { useLocation } from '../context/LocationContext';

// Shown when the visitor first reaches the shop. Asks for a pincode so every
// price on the site reflects the delivery state/district.
export default function LocationGate({ onDone }) {
  const { setPincode } = useLocation();
  const [pin, setPin] = useState('');
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const check = async (value) => {
    setInfo(null);
    setErr('');
    if (value.length !== 6) return;
    setBusy(true);
    try {
      const { loc, serviceable, reason } = await setPincode(value);
      if (!serviceable) {
        setErr(reason || "We don't deliver to this area yet.");
        setInfo(null);
      } else {
        setInfo(loc);
      }
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  };

  const onChange = (e) => {
    const v = e.target.value.replace(/\D/g, '').slice(0, 6);
    setPin(v);
    if (v.length === 6) check(v);
    else { setInfo(null); setErr(''); }
  };

  return (
    <div className="overlay">
      <div className="modal loc-modal">
        <h3><i className="fas fa-location-dot" /> Where should we deliver?</h3>
        <p className="muted" style={{ marginBottom: 18 }}>
          Enter your pincode so we can show the right prices and delivery for your area.
        </p>

        <div className="field">
          <label>Pincode</label>
          <input
            value={pin}
            onChange={onChange}
            placeholder="6-digit pincode"
            inputMode="numeric"
            autoFocus
          />
        </div>

        {busy ? <p className="muted">Checking…</p> : null}
        {info ? (
          <p className="form-msg ok">
            <i className="fas fa-circle-check" />{' '}
            {[info.city, info.district, info.state].filter(Boolean).join(', ')}
          </p>
        ) : null}
        {err ? <p className="form-msg err">{err}</p> : null}

        <button
          className="consult-btn"
          style={{ width: '100%', marginTop: 16, justifyContent: 'center' }}
          disabled={!info || busy}
          onClick={onDone}
        >
          Continue
        </button>

        <button className="link-btn" onClick={onDone}>Skip for now</button>
      </div>
    </div>
  );
}
